import Component from '../abstracts/Component';

export default class CartComponent extends Component {

  get SELECTORS() {
    return {
      cart: '[data-cart-wrapper]',
      qtyBtn: '.js-qty',
      more: '.more',
      less: '.less',
      shippingRadios: '[data-shipping-method] input[type=radio]',
      shippingRadiosBox: '[data-shipping-method]',
      proceedBtn : '.js-click-and-collect-validation',
      errorMsg : '.js-click-and-collect-validation-error',
      options_checkbox_prefix: "shipping-",
      storeLocator: "[data-storelocator]",
      storeInput: ".sl__stores-list input[name='deliveryMethod']",
      storeRadio: "[data-store-name]",
      storeCard: ".store-card",
      storeLocatorErrorMessage: '.store-not-selected-message',
      shipmentBoxes: '.shipment-col'
    }
  }

  get CLASSES() {
    return {
      checked: 'checked',
      active: 'active',
      lastItem: 'js-cart-remove-last',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.y = 0;
    this.quantityBoxes = this.$component.querySelectorAll(this.SELECTORS.qtyBtn);
    this.shippingRadios = this.$component.querySelectorAll(this.SELECTORS.shippingRadios);
    this.storeLocator = this.$component.querySelector(this.SELECTORS.storeLocator);
    this.storeLocatorErrorMessage = this.$component.querySelector(this.SELECTORS.storeLocatorErrorMessage);
    this.shipmentBoxes = this.$component.querySelector(this.SELECTORS.shipmentBoxes);
  }

  quantityManager() {
    // update url
    let updateQtyUrl = document.querySelector(this.SELECTORS.cart).getAttribute('data-update-qty-url');
    // quantity box looop
    this.quantityBoxes.forEach(quantityBox => {
      let addBtn = quantityBox.querySelector('.more');
      let removeBtn = quantityBox.querySelector('.less');
      let qty = quantityBox.querySelector('.qty');
      //
      addBtn.addEventListener('click', () => {
        // set attribute data
        quantityBox.setAttribute('data-qty', parseInt(quantityBox.getAttribute('data-qty'),10) + 1);
        // go update quantity
        location.href = updateQtyUrl + "&entryNumber=" + quantityBox.getAttribute('data-entry-number') + "&qty=" + quantityBox.getAttribute('data-qty');
      });
      //
      removeBtn.addEventListener('click', (e) => {
        // btn to target , take care i click on the span
        let btn = (e.target.localName == 'i') ? e.target.parentNode : e.target ;
        if ( parseInt(quantityBox.getAttribute('data-qty'),10) > 0 && !btn.classList.contains(this.CLASSES.lastItem) ) {
          // set attribute data
          quantityBox.setAttribute('data-qty', parseInt(quantityBox.getAttribute('data-qty'),10) - 1);
          // go update quantity
          location.href = updateQtyUrl + "&entryNumber=" + quantityBox.getAttribute('data-entry-number') + "&qty=" + quantityBox.getAttribute('data-qty');
        }
      });
    });
  }

  // show or hide store locator
  showOrHideStoreLocator(hide){
    if(this.storeLocator !== null) {
      if (hide) {
        this.storeLocator.classList.add("d-none");
      } else {
        this.storeLocator.classList.remove("d-none");
      }
    }
  }

  //
  clickCollectStoreSelection(event) {
    // click collect select store
    this.$on('click', ({event}) => {
      // input clicked
      const input = event.currentTarget.parentElement.querySelector('input');

      // remove error message in C&C section
      console.log('[CartController] Hiding isStoreNotSelectedError');
      this.storeLocatorErrorMessage.classList.add("hidden");
      this.shipmentBoxes.classList.remove("error");

      // submit selection
      this.submitAjaxCartForm(input);
    }, 'body', this.SELECTORS.storeInput);
  }

  // update delivery method by input
  updateDeliveryMethod(event) {
    // remove active from actual active
    let storeChecked = document.querySelector(this.SELECTORS.storeCard+'.'+this.CLASSES.active);
    if (storeChecked != null) {
      storeChecked.classList.remove(this.CLASSES.active);
    }
    let stores = $('.store-card__content__radio input');
    stores.each((index, store) => {
      store.checked = false;
      }
    )
    // input clicked
    let input = event.currentTarget.parentElement.querySelector('input');
    //
    this.submitAjaxCartForm(input);
  }

  // ajax call to update delivery method
  submitAjaxCartForm(input) {
    // remove error message in C&C section
    this.storeLocatorErrorMessage.classList.add("hidden");
    this.shipmentBoxes.classList.remove("error");

    let deliveryMethod = input.value;
    let selectedStore = '';
    if (input.getAttribute('data-click-collect')) {
      selectedStore = input.getAttribute('id');
    }

    const params = new URLSearchParams({
      'set-delivery-mode': 'updateDelivery',
      'code': deliveryMethod,
      'selectedStore': selectedStore
    });
    const url = `${document.location.origin}${document.location.pathname}?${params}`;

    // go ajax
    fetch(url,
      {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
      }
    ).then(res => {
        return res.text();
      }
    ).then( data =>{
      console.log('[CartController]fetch done:', deliveryMethod);
      let html = new DOMParser().parseFromString(data, 'text/html');
      // Searching errors
      let isStoreNotSelectedError = (html.querySelector('.store-not-selected-flag') !== null);
      console.log("isStoreNotSelectedError: " + isStoreNotSelectedError);
      // Showing errors in C&C section
      if (isStoreNotSelectedError){
          console.log('[CartController] Showing isStoreNotSelectedError');
          this.storeLocatorErrorMessage.classList.remove("hidden");
          this.shipmentBoxes.classList.add("error");
      }
    });
  }

  bindEvents() {
    this.quantityManager();

    // clicks on radio
    this.shippingRadios.forEach(checkbox => {
      // if is
      let isClickAndCollectCheckbox = checkbox.id.includes("Click-and-Collect");
      // listen to the click
      checkbox.addEventListener('change',(event) => {
        // hide/show store locator
        this.showOrHideStoreLocator(!isClickAndCollectCheckbox);
        // update delivery method if not click and collect
        this.updateDeliveryMethod(event);
        // change method class
        let checboxBoxChecked = document.querySelector(this.SELECTORS.shippingRadiosBox+'.'+this.CLASSES.checked);
        let checboxBox = checkbox.closest(this.SELECTORS.shippingRadiosBox);
        // remove class from checked
        checboxBoxChecked.classList.remove(this.CLASSES.checked);
        // add class to selected
        checboxBox.classList.add(this.CLASSES.checked);
      });
    });

    // on show results
    this.$on(this.$customEvents.O2O.ccStoresShowResults,(e) => {
      // function to listen radio change
      this.clickCollectStoreSelection(e);
    });

    // click and collect selecting store
    this.$on('click', ({event}) => {
      // search parent li
      let radioBox = event.target.closest('li');
      // check if box is active
      if (radioBox.classList.contains(this.CLASSES.active)) {
        return;
      }
      // check click on more details
      if (event.target.className == 'store-card__content__details__actions'
        || event.target.className == 'more'
        || event.target.className == 'less'
        ) return;
      // remove active from actual active
      let storeChecked = document.querySelector(this.SELECTORS.storeCard+'.'+this.CLASSES.active);
      if (storeChecked != null) {
        storeChecked.classList.remove(this.CLASSES.active);
      }
      // add active class
      radioBox.classList.add(this.CLASSES.active);
      // select radio in the box clicked if is not clicked on radio or label
      if (event.target.nodeName != 'INPUT' && event.target.nodeName != 'LABEL') {
        let storeRadio = radioBox.querySelector(this.SELECTORS.storeRadio);
        storeRadio.click();
      }
    },'body', this.SELECTORS.storeCard);

    let isStoreNotSelectedError = this.$component.querySelector('.store-not-selected-flag') !== null;
    console.log("isStoreNotSelectedError: " + isStoreNotSelectedError);
    // Showing errors in C&C section
    if (isStoreNotSelectedError){
        console.log('[CartController] Showing isStoreNotSelectedError');
        this.storeLocatorErrorMessage.classList.remove("hidden");
        this.shipmentBoxes.classList.add("error");
    }

  }

  render() {
    this.bindEvents();
  }
}

